import React from "react";
import { HomeBooks } from "../assets/images";

import { useSelector } from "react-redux";
import { RootState } from "../redux/store/store";
import { useNavigate } from "react-router-dom";

const WelcomeCard = () => {
  const userData = useSelector((state: RootState) => state.user.userData);
  const fullName = userData?.fullName || "Étudiant";
  const navigate = useNavigate();

  return (
    <div className="relative w-full overflow-hidden bg-gradient-to-br from-[#021B19] to-[#05322B] rounded-[3rem] p-12 md:p-20 shadow-[0_40px_100px_rgba(0,0,0,0.1)] border border-white/5">
      {/* Subtle Background Glow */}
      <div className="absolute -top-24 -right-24 w-[400px] h-[400px] bg-primary/10 rounded-full blur-[100px]"></div>
      
      <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-12">
        <div className="flex-1 text-center md:text-left">
          <h1 className="text-5xl md:text-7xl font-black text-white mb-6 tracking-tight leading-none">
            Bonjour, <span className="text-primary italic">{fullName}</span>
          </h1>
          
          <p className="text-white/60 text-lg md:text-xl max-w-2xl mb-12 font-medium leading-relaxed">
            Votre parcours vers l'excellence continue ici. Prêt pour votre prochaine leçon ?
          </p>
          
          <div className="flex flex-wrap items-center justify-center md:justify-start gap-6">
            <button 
              onClick={() => navigate("/dashboard/offer-student")}
              className="px-12 py-5 bg-primary text-white font-black uppercase tracking-[0.2em] text-[11px] rounded-2xl shadow-2xl shadow-primary/20 hover:shadow-primary/40 hover:-translate-y-1 transition-all duration-500"
            >
              Continuer l'apprentissage
            </button>
          </div>
        </div>

        <div className="hidden lg:block">
           <div className="w-24 h-24 rounded-3xl bg-white/5 backdrop-blur-xl border border-white/10 flex items-center justify-center text-primary rotate-12 shadow-2xl">
              <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 24 24"><path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3z"/><path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82z"/></svg>
           </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeCard;
